module.exports = __webpack_public_path__ + "static/media/toc.925d44dd.png";